"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleDriveGetFileById = exports.googleDriveGetFileByIdResultSchema = exports.googleDriveGetFileByIdArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.googleDriveGetFileByIdArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('get-file-by-id', zod_1.z.object({
    fileId: zod_1.z.string().describe("The google drive file's fileId"),
}));
var googleDriveFileSchema = zod_1.z.object({
    kind: zod_1.z.string().describe('Identifies what kind of resource this is'),
    mimeType: zod_1.z.string().describe('The MIME type of the file'),
    name: zod_1.z.string().describe('The name of the file'),
    id: zod_1.z.string().describe('The id of this file'),
});
exports.googleDriveGetFileByIdResultSchema = (0, common_1.PipedreamNodeResultSchema)(googleDriveFileSchema);
exports.googleDriveGetFileById = (0, common_1.createToolMetadata)({
    id: 'googleDriveGetFileById',
    displayName: 'Google Drive Get File By Id',
    displayDescription: "Get a google drive file's metadata by id",
    category: 'integration',
    color: common_1.BRAND_COLORS.GOOGLE_DRIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_DRIVE),
    icon: 'google_drive',
    argsSchema: exports.googleDriveGetFileByIdArgsSchema,
}, exports.googleDriveGetFileByIdResultSchema);
